module.exports = __webpack_public_path__ + "static/media/janio_big_logo.d3cf9b77.svg";